<template>
    <div class="speed-limit-container" v-if="this.currentAnsiSegment && this.currentAnsiSegment.speed_limit_value" title="Speed Limit">
        <div class="black-outline">
            <!-- <div class="speed-limit-text">
                <div class="text-box">Speed</div>
                <div class="text-box">Limit</div>
            </div> -->
            <div class="speed-limit-number-container">
                <div 
                  class="speed-limit-number"
                  :class="speedLimitLength == 1 ? 'large-font' : speedLimitLength == 2 ? 'medium-font' : speedLimitLength >= 3 ? 'small-font' : null"
                >{{ currentAnsiSegment.speed_limit_value }}</div>
                <h6>KMH</h6>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'MMP_ANSI_SpeedLimit',
  props: ['currentAnsiSegment'],
  computed: {
    speedLimitLength() {
        // eventually this will change to this.currentAnsiSegment.speed_limit_value
        return this.currentAnsiSegment.speed_limit_value.split(',').length
    }
  }
}
</script>

<style scoped>
.speed-limit-container {
    /* Positioned near the ANSI segment-navigation toolbar via the global
       .mmp-tools-speed-limit rule in MapManagementPlatform.css. */
    flex-shrink: 0;
    height: 50px;
    width: 66px;
    background: linear-gradient(180deg, #ffffff 0%, #f1f1f1 100%);
    color: #111;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 9px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.85);
    font-family: 'Arial Narrow', 'Helvetica Neue', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    user-select: none;
}

.black-outline {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    border: 2.5px solid #111;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 7px 4px 6px;
}

.speed-limit-text {
    font-weight: 400;
    letter-spacing: 0.4px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.text-box {
    font-size: 12px;
    line-height: 1.1;
    text-transform: uppercase;
}

.speed-limit-number-container {
    font-weight: 600;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    line-height: 1;
}

.speed-limit-number {
    line-height: 1;
}

.large-font {
    font-weight: 800;
    font-size: 23px;
}

.medium-font {
    font-weight: 800;
    font-size: 22px;
}

.small-font {
    font-weight: 800;
    font-size: 13px;
}

.speed-limit-number-container h6 {
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.4px;
    margin: 3px 0 0;
    color: #555;
}
</style>